<div
    class="avi-metrics-collection-data-grid__selectors-section"
    *ngIf="configWithMetrics.includeTimeframeSelector || configWithMetrics.includeMetricsValueSelector"
>
    <!-- timeframe selector -->
    <timeframe-selector
        class="avi-metrics-collection-data-grid__selector"
        *ngIf="configWithMetrics.includeTimeframeSelector"
    ></timeframe-selector>

    <!-- metrics selector -->
    <metric-values-selector *ngIf="configWithMetrics.includeMetricsValueSelector"></metric-values-selector>
</div>

<!-- avi-collection-data-grid (with config added with the metrics cell templateRef) -->
<avi-collection-data-grid
    [config]="configWithMetrics"
    [gridTitle]="gridTitle"
    (onSelectionChange)="onRowSelectionChange($event)"
></avi-collection-data-grid>

<ng-template
    #metricsCellTemplateRef
    let-row
    let-index="index"
    let-fieldId="fieldId"
>
    <avi-metrics-cell
        [series]="row.getMetric(fieldId)?.getMainSeries()"
        [isLoading]="row.getMetric(fieldId)?.isLoading()"
    ></avi-metrics-cell>
</ng-template>
